import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { ShoppingWithSocial } from './ShoppingWithSocial';
import { ShoppingWithMobileDescription } from './ShoppingWithMobileDescription';
import { ShoppingWithLinks } from './ShoppingWithLinks';
import styles from './styles/ShoppingWithTopModule.scss';

function ShoppingWithTopModuleComponent({ shoppingWith, onOpenAllShoppers, isMobile }) {
    const { title, subTitle, description, mobileImage, mainImage } = shoppingWith || {};

    if (mainImage && title && description) {
        return (
            <div className={styles.wrapper}>
                <div data-tn="saturday-shopper-main-img-wrapper" className={styles.imageWrapper}>
                    {isMobile ? (
                        <img
                            src={mobileImage || mainImage}
                            className={styles.mobileImage}
                            alt={title}
                        />
                    ) : (
                        <img src={mainImage} className={styles.mainImage} alt={title} />
                    )}
                </div>
                <div className={styles.detailsWrapper}>
                    <div className={styles.titleWrapper}>
                        <h2
                            data-tn="saturday-shopper-title"
                            className={styles.title}
                            dangerouslySetInnerHTML={{ __html: title }}
                        />
                        <h3
                            data-tn="saturday-shopper-subtitle"
                            className={styles.subTitle}
                            dangerouslySetInnerHTML={{ __html: subTitle }}
                        />
                    </div>
                    {isMobile ? (
                        <div>
                            <ShoppingWithMobileDescription
                                shoppingWith={shoppingWith}
                                onOpenAllShoppers={onOpenAllShoppers}
                            />
                        </div>
                    ) : (
                        <div>
                            <div
                                className={styles.description}
                                dangerouslySetInnerHTML={{ __html: description }}
                                data-tn="saturday-shopper-description"
                            />
                            <div className={styles.footer}>
                                <ShoppingWithSocial shoppingWith={shoppingWith} />
                            </div>
                            <div className={styles.footer}>
                                <ShoppingWithLinks shoppingWith={shoppingWith} />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    return null;
}

ShoppingWithTopModuleComponent.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    shoppingWith: PropTypes.object.isRequired,
    onOpenAllShoppers: PropTypes.func.isRequired,
};

export const ShoppingWithTopModule = createFragmentContainer(ShoppingWithTopModuleComponent, {
    shoppingWith: graphql`
        fragment ShoppingWithTopModule_shoppingWith on ShoppingWith {
            ...ShoppingWithSocial_shoppingWith
            ...ShoppingWithMobileDescription_shoppingWith
            ...ShoppingWithLinks_shoppingWith
            mainImage
            mobileImage
            description
            title
            subTitle
        }
    `,
});
